module.exports = __webpack_public_path__ + "static/media/progman_20.c00b3134.ico";